import { inject, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { filter, map } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  router = inject(Router)
  activatedRoute = inject(ActivatedRoute)

  pageInfo = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.getChild(this.activatedRoute)),
      map(route => route.snapshot.data)
    )
  )

  private getChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild
    }

    return route
  }
}
